// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"8544c87b","369":"6ff7026e","373":"7dfd6ef6","651":"81b02d77","875":"3c87a080","880":"0c2009af","892":"2daab054"}[chunkId] + ".chunk.js";
};